/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react'
import '../../Style/Table4.css'
import MaterialTable from 'material-table'
import AddIcon from '@material-ui/icons/Add'
import {
  Button,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
} from '@material-ui/core'
import { getGenderActivitiesByForm } from '../../../../../services/Elegibilidad/get'
import { updateGenderActivities } from '../../../../../services/Elegibilidad/put'
import { Modal41 } from '../../Modals/ModalSec4/Modal41'
import { deleteGenderActivities } from '../../../../../services/Elegibilidad/delete'
import { useFormElegibilidad } from '../../../../../context/ElegibilidadContext'
import EditIcon from '@mui/icons-material/Edit'
import DeleteIcon from '@mui/icons-material/Delete'
import { useEligibility } from '../../../../../context/EligibilityContext'
import swal from 'sweetalert'

const Table41 = ({ formik }) => {
  const [state, dispatch] = useEligibility()
  const { idElegibilityForm } = useFormElegibilidad()
  const [tableData, setTableData] = useState([])
  const [open, setOpen] = useState(false)
  const [addOther, setAddOher] = useState(true)
  let optionValue = null
  let womenValue = null
  let menValue = null
  let activityValue = null

  const getDataTable = async () => {
    try {
      const response = await getGenderActivitiesByForm(idElegibilityForm)
      setTableData(response.Data)
      optionValue = null
      const result = response.Data.filter((obj) => obj.IdActivity === 1)
      if (result.length === 0) setAddOher(true)
      else {
        setAddOher(false)
      }
      const resultValidateNull = response.Data.filter(
        (obj) => obj.Description === null,
      )

      const resultValidate = response.Data.filter(
        (obj) => obj.Description === '',
      )

      if (resultValidateNull.length === 0 && resultValidate.length === 0)
        formik.setFieldValue('validTable41', true)
      else {
        formik.setFieldValue('validTable41', false)
      }
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    if (
      state.step === 4 &&
      idElegibilityForm !== undefined &&
      idElegibilityForm !== null &&
      tableData.length === 0
    ) {
      getDataTable()
    }
  }, [state.step])

  const handleActualizar = async (data) => {
    if (optionValue === 'no') {
      const body = {
        IdElegibilityAnswer: data.IdElegibilityAnswer,
        IdGenderActivity: data.IdGenderActivity,
        IdActivity: data.IdActivity,
        ActivityDetail: data.ActivityDetail,
        Men: false,
        Women: false,
        Description: 'NA',
        isDefault: data.isDefault,
        isNotApply: false,
      }

      // if (
      //   data.Description !== '' &&
      //   data.Description !== null &&
      //   data.Description !== 'NA'
      // ) {
      //   swal({
      //     title:
      //       'Al seleccionar "No Aplica" no debe de describir la actividad ',
      //     icon: 'error',
      //   })
      // } else if (
      //   data.Men !== null ||
      //   (data.Women !== null && data.Men !== false && data.Women !== false)
      // )
      //   swal({
      //     title:
      //       'Al seleccionar "No Aplica" no debe seleccionar por quien es realizada la actividad',
      //     icon: 'error',
      //   })
      // else {
      const response = await updateGenderActivities(body)
      if (response.Success) {
        getDataTable()
        optionValue = null
      }
    } else {
      if (optionValue === 'si' || data.isApply === true) {
        const body = {
          IdElegibilityAnswer: data.IdElegibilityAnswer,
          IdGenderActivity: data.IdGenderActivity,
          IdActivity: data.IdActivity,
          ActivityDetail: data.ActivityDetail,
          Men: menValue !== null ? menValue : false,
          Women: womenValue !== null ? womenValue : false,
          Description: activityValue,
          isDefault: data.isDefault,
          isNotApply: true,
        }

        if (activityValue === '' || activityValue === null) {
          activityValue = null
          menValue = null
          womenValue = null
          swal({
            title: 'Al seleccionar "Si" debe de describir la actividad ',
            icon: 'error',
          })
        } else if (activityValue === 'NA') {
          activityValue = null
          menValue = null
          womenValue = null
          swal({
            title: 'Al seleccionar "Si" la descripción no debe ser "NA"',
            icon: 'error',
          })
        } else if (
          (menValue === null && womenValue === null) ||
          (menValue === false && womenValue === false)
        ) {
          activityValue = null
          menValue = null
          womenValue = null
          swal({
            title:
              'Al seleccionar "Si" debe selecionar por quien es realizada la actividad',
            icon: 'error',
          })
        } else {
          const response = await updateGenderActivities(body)
          if (response.Success) {
            getDataTable()
            optionValue = null
            activityValue = null
            menValue = null
            womenValue = null
          }
        }
      }
    }
  }

  const handleDelete = async (id) => {
    try {
      await deleteGenderActivities(id)
      getDataTable()
    } catch (error) {
      console.log(error)
    }
  }

  const columns = [
    {
      title: 'Tipo de actividad',
      field: 'ActivityDetail',
      sorting: false,
      filtering: false,
      // cellStyle: { background: '#009688' },
      // headerStyle: { color: '#fff' },
      editable: 'never',
    },
    {
      title: 'Aplica',
      field: 'isNotApply',
      sorting: false,
      filtering: false,
      // cellStyle: { background: '#009688' },
      // headerStyle: { color: '#fff' },
      type: 'boolean',
      align: 'left',
      editComponent: (rowData) => {
        return (
          <RadioGroup
            aria-labelledby="demo-radio-buttons-group-label"
            name="radio-buttons-group"
            row
            onChange={(e) => {
              // e.preventDefault()
              // setLoading(false)
              optionValue = e.target.value

              const menElemen = document.getElementById('checkMen')
              const womenElemen = document.getElementById('checkWomen')
              const activityElemen = document.getElementById('descActivity')
              if (e.target.value === 'no') {
                activityValue = ''
                menElemen.checked = false
                menElemen.disabled = true
                womenElemen.checked = false
                womenElemen.disabled = true
                activityElemen.value = 'NA'
                activityElemen.disabled = true
              } else {
                menElemen.disabled = false
                womenElemen.disabled = false
                activityElemen.disabled = false
                if (activityElemen.value === 'NA') {
                  activityElemen.value = ''
                  activityValue = ''
                }
              }

              // setLoading(true)
              // setvalueCheckMen(!valueCheckMen)
              // prueba = !prueba

              // // otro
              // var data = { ...props.rowData }
              // data.name = e.target.value
              // data.surname = e.target.value.toLocaleUpperCase()
              // props.onRowDataChange(data)
            }}
            defaultValue={
              rowData.rowData.isApply === true
                ? 'si'
                : rowData.rowData.isApply === false
                ? 'no'
                : null
            }
          >
            <FormControlLabel value="si" control={<Radio />} label="Si" />
            <FormControlLabel value="no" control={<Radio />} label="No" />
          </RadioGroup>
        )
      },
      render: (rowData) => (
        <RadioGroup
          aria-labelledby="demo-radio-buttons-group-label"
          value={rowData.isApply}
          name="radio-buttons-group"
          row
        >
          <FormControlLabel
            value={true}
            control={<Radio />}
            label="Si"
            disabled
          />
          <FormControlLabel
            value={false}
            control={<Radio />}
            label="No"
            disabled
          />
        </RadioGroup>
      ),
    },
    {
      title: 'Realizada por hombres',
      field: 'Men',
      sorting: false,
      filtering: false,
      // cellStyle: { background: '#009688' },
      // headerStyle: { color: '#fff' },
      type: 'boolean',
      align: 'center',
      editComponent: (props) => {
        if (menValue === null) {
          menValue = props.value
        }
        return (
          <Grid style={{ marginLeft: '32%' }}>
            <input
              type="checkbox"
              id="checkMen"
              disabled={!props.rowData.isApply}
              defaultValue={props.value}
              defaultChecked={props.value}
              style={{ width: '20px', height: '20px' }}
              onChange={(e) => {
                if (e.target.checked === true) {
                  menValue = true
                } else {
                  menValue = false
                }
              }}
            />
          </Grid>
        )
      },
    },

    {
      title: 'Realizada por mujeres',
      field: 'Women',
      sorting: false,
      filtering: false,
      // cellStyle: { background: '#009688' },
      // headerStyle: { color: '#fff' },
      type: 'boolean',
      align: 'center',
      editComponent: (props) => {
        // womenValue = props.value
        if (womenValue === null) {
          womenValue = props.value
        }
        return (
          <Grid style={{ marginLeft: '32%' }}>
            <input
              type="checkbox"
              id="checkWomen"
              // value={props.value}
              disabled={!props.rowData.isApply}
              defaultChecked={props.value}
              style={{ width: '20px', height: '20px' }}
              onChange={(e) => {
                if (e.target.checked === true) {
                  womenValue = true
                } else {
                  womenValue = false
                }
              }}
            />
          </Grid>
        )
      },
    },
    {
      title: 'Describir actividad',
      field: 'Description',
      sorting: false,
      filtering: false,
      // cellStyle: { background: '#009688' },
      // headerStyle: { color: '#fff' },
      align: 'rigth',
      editComponent: (props) => {
        if (activityValue === null) {
          activityValue = props.value
        }
        return (
          <input
            disabled={!props.rowData.isApply}
            id="descActivity"
            defaultValue={props.value}
            onChange={(e) => {
              activityValue = e.target.value
            }}
            maxLength={200}
          />
        )
      },
      validate: (rowData) =>
        rowData.Description?.length > 200 ? 'Máximo 200 caracteres' : '',
    },
  ]
  return (
    <div className="App">
      <Grid container spacing={1}>
        <Grid item xs={12} sm={12} md={12}>
          <MaterialTable
            columns={columns}
            data={tableData}
            editable={{
              // isEditable: (rowData) => {
              //   console.log('el rowdata')
              //   return rowData.isImplement === true
              // }, // only name(a) rows would be editable
              isDeleteHidden: (rowData) => rowData.IdActivity !== 1,
              onRowUpdate: (newData, oldData, rowData) =>
                new Promise((resolve, reject) => {
                  handleActualizar(newData)
                  resolve()
                  setTimeout(() => {}, 1000)
                }),
              onRowDelete: (oldData) =>
                new Promise((resolve, reject) => {
                  handleDelete(oldData.IdGenderActivity)
                  setTimeout(() => resolve(), 500)
                }),
            }}
            actions={[
              addOther
                ? {
                    icon: () => (
                      <Button
                        variant="contained"
                        color="success"
                        style={{ backgroundColor: '#27C27D', color: '#FFFFFF' }}
                        startIcon={<AddIcon style={{ color: 'white' }} />}
                      >
                        Agregar actividad
                      </Button>
                    ),
                    tooltip: 'Agregar',
                    position: 'toolbar',
                    onClick: () => {
                      setOpen(true)
                    },
                  }
                : {
                    icon: () => (
                      <Button
                        variant="contained"
                        color="success"
                        disabled
                        startIcon={<AddIcon style={{ color: 'white' }} />}
                      >
                        Agregar actividad
                      </Button>
                    ),
                    tooltip: 'Agregar',
                    position: 'toolbar',
                  },
            ]}
            onSelectionChange={(selectedRows) => console.log(selectedRows)}
            options={{
              sorting: true,
              search: true,

              searchFieldAlignment: 'right',
              searchAutoFocus: true,
              searchFieldVariant: 'standard',
              filtering: true,
              paging: false,
              pageSizeOptions: [2, 5, 10, 20],
              pageSize: 5,
              paginationType: 'stepped',
              showFirstLastPageButtons: false,
              paginationPosition: 'bottom',

              exportFileName: 'TableData',
              addRowPosition: 'first',
              actionsColumnIndex: -1,
              showSelectAllCheckbox: false,
              showTextRowsSelected: false,
              toolbarButtonAlignment: 'left',
              selectionProps: (rowData) => ({
                disabled: rowData.age == null,
                // color:"primary"
              }),

              rowStyle: (data, index) =>
                index % 2 === 0 ? { background: '#f5f5f5' } : null,
              headerStyle: { background: '#004BCE', color: '#fff' },
            }}
            localization={{
              body: {
                editRow: {
                  deleteText: '¿Está seguro de eliminar el registro?',
                },
                emptyDataSourceMessage: 'No hay registros a desplegar',
              },
              header: {
                actions: 'Acciones',
              },
              toolbar: {
                searchPlaceholder: 'Buscar',
              },
            }}
            title=" "
            icons={{
              Add: () => <AddIcon style={{ color: 'green' }} />,
              Edit: () => <EditIcon style={{ color: '#0d53ad' }} />,
              Delete: () => <DeleteIcon style={{ color: 'red' }} />,
            }}
          />
        </Grid>
      </Grid>
      <Modal41 open={open} setOpen={setOpen} getDataTable={getDataTable} />
    </div>
  )
}

export default Table41
